import React from "react";
import "./styles.scss";
import { GetIconByName } from "../../config/icon";

const Index = ({ data, onClick }) => {
  let inputElement = null;

  inputElement = (
    <>
      <div className={`link-wrapper  ${data.mainLayerStyles}`}>
        <div className={"lw__title"}>{data.title}</div>
        <div className={"lw__link"} onClick={onClick}>
          {data.link}
        </div>
      </div>
    </>
  );

  return (
    <>
      <>{inputElement}</>
    </>
  );
};

export default Index;
